import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import { AuthProvider } from 'react-oidc-context';

import { store } from './state/store';
import './i18n.js';
import logger from './logger/index.js';

const {
  REACT_APP_AUTHORITY,
  REACT_APP_CLIENT_ID,
  REACT_APP_REDIRECT_URI,
  REACT_APP_LOGOUT_URI,
} = process.env;

const cognitoAuthConfig = {
  authority: REACT_APP_AUTHORITY,
  client_id: REACT_APP_CLIENT_ID,
  redirect_uri: REACT_APP_REDIRECT_URI,
  post_logout_redirect_uri: REACT_APP_LOGOUT_URI,
  response_type: 'code',
  scope: 'email openid phone',
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <Provider store={store}>
        <App />
      </Provider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
